// CSS Modules - component class name prefix: BigNavButtons__

<template>
  <div :class="[$style.container, 'columns is-multiline is-mobile']">
    <div class="column is-half">
      <a :class="$style.bigNavButton" href="#" target="_self">
        <figure>
          <div :class="$style.image" :style="{backgroundImage: 'url(https://shop.wika.de/upload/PIC_SH_DialThermometer_de_de_78913.png)'}">
            <img src="https://shop.wika.de/upload/PIC_SH_DialThermometer_de_de_78913.png" />
          </div>
          <figcaption>
            <h3>Zeiger-<br />thermometer</h3>
          </figcaption>
        </figure>
      </a>
    </div>
    <div class="column is-half">
      <a :class="$style.bigNavButton" href="#" target="_self">
        <figure>
          <div :class="$style.image" :style="{backgroundImage: 'url(https://shop.wika.de/upload/PIC_SH_DialThermometer_de_de_78913.png)'}">
            <img src="https://shop.wika.de/upload/PIC_SH_DialThermometer_de_de_78913.png" />
          </div>
          <figcaption>
            <h3>Zeiger-<br />thermometer</h3>
          </figcaption>
        </figure>
      </a>
    </div>
    <div class="column is-half">
      <a :class="$style.bigNavButton" href="#" target="_self">
        <figure>
          <div :class="$style.image" :style="{backgroundImage: 'url(https://shop.wika.de/upload/PIC_SH_DialThermometer_de_de_78913.png)'}">
            <img src="https://shop.wika.de/upload/PIC_SH_DialThermometer_de_de_78913.png" />
          </div>
          <figcaption>
            <h3>Zeiger-<br />thermometer</h3>
          </figcaption>
        </figure>
      </a>
    </div>
    <div class="column is-half">
      <a :class="$style.bigNavButton" href="#" target="_self">
        <figure>
          <div :class="$style.image" :style="{backgroundImage: 'url(https://shop.wika.de/upload/PIC_SH_DialThermometer_de_de_78913.png)'}">
            <img src="https://shop.wika.de/upload/PIC_SH_DialThermometer_de_de_78913.png" />
          </div>
          <figcaption>
            <h3>Zeiger-<br />thermometer</h3>
          </figcaption>
        </figure>
      </a>
    </div>
    <div class="column is-half">
      <a :class="$style.bigNavButton" href="#" target="_self">
        <figure>
          <div :class="$style.image" :style="{backgroundImage: 'url(https://shop.wika.de/upload/PIC_SH_DialThermometer_de_de_78913.png)'}">
            <img src="https://shop.wika.de/upload/PIC_SH_DialThermometer_de_de_78913.png" />
          </div>
          <figcaption>
            <h3>Zeiger-<br />thermometer</h3>
          </figcaption>
        </figure>
      </a>
    </div>
    <div class="column is-half">
      <a :class="$style.bigNavButton" href="#" target="_self">
        <figure>
          <div :class="$style.image" :style="{backgroundImage: 'url(https://shop.wika.de/upload/PIC_SH_DialThermometer_de_de_78913.png)'}">
            <img src="https://shop.wika.de/upload/PIC_SH_DialThermometer_de_de_78913.png" />
          </div>
          <figcaption>
            <h3>Zeiger-<br />thermometer</h3>
          </figcaption>
        </figure>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "BigNavButtons"
};
</script>

<style module lang="scss">
@import "./BigNavButtons.scss";
</style>
